import { render, staticRenderFns } from "./ParkingRateSetting.vue?vue&type=template&id=5bfb9117&scoped=true"
import script from "./ParkingRateSetting.vue?vue&type=script&lang=js"
export * from "./ParkingRateSetting.vue?vue&type=script&lang=js"
import style0 from "./ParkingRateSetting.vue?vue&type=style&index=0&id=5bfb9117&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfb9117",
  null
  
)

export default component.exports